<script lang="ts" setup>
  import { computed } from 'vue'
  import { useTheme } from '~/composables/useTheme'
  import type { GenericObject } from '~/types/common'
  import { palettes } from '~/utils/colors/palettes'

  const { currentTheme } = useTheme()

  const themeStyles = computed<GenericObject>(() => {
    const palette = palettes[currentTheme.value]
    const styles: Record<string, string> = {}

    // Flatten the palette into CSS custom properties
    const flattenObject = (obj: GenericObject, prefix = ''): void => {
      for (const key in obj) {
        const value = obj[key]
        if (typeof value === 'object') {
          flattenObject(value, `${prefix}${key}-`)
        } else {
          styles[`--${prefix}${key}`] = value
        }
      }
    }

    flattenObject(palette)
    return styles
  })
</script>

<template>
  <div :style="themeStyles">
    <slot />
  </div>
</template>
